// Batch actions functionality for selectable tables
let eventListeners = [];

function initializeBatchActions() {
  // Find all batch action forms on the page
  const batchForms = document.querySelectorAll('.batch-actions-form');

  if (batchForms.length === 0) return;

  // Clean up existing event listeners first
  cleanupEventListeners();

  // Initialize each form independently
  batchForms.forEach(form => {
    initializeBatchActionsForForm(form);
  });
}

function initializeBatchActionsForForm(form) {
  const selectAllCheckbox = form.querySelector('.select-all');
  const recordCheckboxes = form.querySelectorAll('.record-checkbox');
  const batchActionsDiv = form.querySelector('.batch-actions');
  const selectedCountSpan = form.querySelector('.selected-count');
  const batchActionButton = form.querySelector('.batch-action-button');

  if (!selectAllCheckbox || !recordCheckboxes.length) return;

  function updateSelectAllState() {
    const checkedBoxes = form.querySelectorAll('.record-checkbox:checked');
    selectAllCheckbox.checked = checkedBoxes.length === recordCheckboxes.length;
    selectAllCheckbox.indeterminate = checkedBoxes.length > 0 && checkedBoxes.length < recordCheckboxes.length;
  }

  function updateBatchActionsUI() {
    const checkedBoxes = form.querySelectorAll('.record-checkbox:checked');
    const count = checkedBoxes.length;

    if (count > 0) {
      batchActionsDiv.style.display = 'block';
      selectedCountSpan.textContent = `${count} record${count === 1 ? '' : 's'} selected`;
      batchActionButton.disabled = false;
    } else {
      batchActionsDiv.style.display = 'none';
      batchActionButton.disabled = true;
    }
  }

  // Create named functions for event handlers so we can remove them later
  const selectAllHandler = function() {
    recordCheckboxes.forEach(checkbox => {
      checkbox.checked = this.checked;
    });
    updateBatchActionsUI();
  };

  const checkboxHandler = function() {
    updateSelectAllState();
    updateBatchActionsUI();
  };

  const formSubmitHandler = function(e) {
    const checkedBoxes = form.querySelectorAll('.record-checkbox:checked');
    if (checkedBoxes.length === 0) {
      e.preventDefault();
      alert('Please select at least one record.');
      return;
    }

    const actionText = e.submitter.textContent.trim();
    const count = checkedBoxes.length;

    if (!confirm(`Are you sure you want to ${actionText.toLowerCase()} ${count} record${count === 1 ? '' : 's'}?`)) {
      e.preventDefault();
    }
  };

  // Add event listeners and store references
  selectAllCheckbox.addEventListener('change', selectAllHandler);
  eventListeners.push({ element: selectAllCheckbox, event: 'change', handler: selectAllHandler });

  recordCheckboxes.forEach(checkbox => {
    checkbox.addEventListener('change', checkboxHandler);
    eventListeners.push({ element: checkbox, event: 'change', handler: checkboxHandler });
  });

  form.addEventListener('submit', formSubmitHandler);
  eventListeners.push({ element: form, event: 'submit', handler: formSubmitHandler });
}

function cleanupEventListeners() {
  eventListeners.forEach(({ element, event, handler }) => {
    element.removeEventListener(event, handler);
  });
  eventListeners = [];
}

// Initialize on DOMContentLoaded (for initial page load)
document.addEventListener('DOMContentLoaded', initializeBatchActions);

// Initialize on Turbo navigation events
document.addEventListener('turbo:load', initializeBatchActions);
document.addEventListener('turbo:render', initializeBatchActions);

// Clean up when navigating away
document.addEventListener('turbo:before-visit', cleanupEventListeners);
